import React from 'react'
import { Box } from '@mui/material'

import { Button } from '~components/common'

interface SaveCancelButtonsProps {
  onSave: () => void
  onCancel: () => void
  isSaveDisabled: boolean
  saveText?: string
  cancelText?: string
}

const SaveCancelButtons: React.FC<SaveCancelButtonsProps> = ({
  onSave,
  onCancel,
  isSaveDisabled,
  saveText = 'Save',
  cancelText = 'Cancel',
}) => {
  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'flex-end',
        width: '100%',
        mt: 2,
        gap: 2,
      }}
    >
      <Button variant='outlined' color='secondary' onClick={onCancel}>
        {cancelText}
      </Button>
      <Button variant='contained' color='secondary' onClick={onSave} disabled={isSaveDisabled}>
        {saveText}
      </Button>
    </Box>
  )
}

export default SaveCancelButtons
